module.exports = __webpack_public_path__ + "img/onegod.812fed4b.png";